<template>
    <div class="loader-wrapper" v-if="usePos.loadingProgress">
        <div class="loader"><span></span><span></span><span></span><span></span><span></span></div>
    </div>
    <div v-if="usePos.showDivisionModal" class="modal show d-block" tabindex="-1" style="background:rgba(0,0,0,0.5);">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Point Of Sales</h5>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Divisi</label>
                            <select v-model="usePos.formPos.divisi" class="form-select">
                                <option :value="null" disabled>Select Divisi</option>
                                <option v-for="option in divisiOptions" :key="option.ID" :value="option">
                                    {{ option?.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">DivisiTeam</label>
                            <select v-model="usePos.formPos.divisi_team" class="form-select">
                                <option :value="null" disabled>Select DivisiTeam</option>
                                <option v-for="option in divisiTeamOptions" :key="option.ID" :value="option">
                                    {{ option?.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="usePos.showDivisionModal = false;">
                        Lanjut
                    </button>
                </div>
            </div>
        </div>
    </div>
    <Card3 colClass="col-md-12 pt-2" pre="true" preClass="mt-1 mb-0" cardhaderClass="card-no-border pb-0" headerTitle="true"
        :title="`POINT OF SALES ${usePos.formPos?.divisi_team?.name??' Divisi Team not selected'}`" :desc="`TIME: ${datetime.toLocaleDateString()} ${datetime.toLocaleTimeString()}`">
        <div class="row shopping-wizard">
            <div class="col-12">
                <div class="row shipping-form g-3">
                    <div class="col-xl-8 shipping-border">
                        <!-- Pass addToCart as event handler -->
                        <div class="nav nav-pills horizontal-options shipping-options" id="cart-options-tab" role="tablist"
                            aria-orientation="vertical"><a class="nav-link b-r-0 " v-for="(item, index) in tab" :key="index"
                                :id="item.id" role="tab" aria-controls="order-wizard"
                                v-bind:class="{ 'active': item.id === usePos.activeClass+'-wizard-tab' }" aria-selected="true">
                                <div class="cart-options">
                                    <div class="stroke-icon-wizard"><i class="fa-solid " :class="item.icon"></i></div>
                                    <div class="cart-options-content">
                                        <h6>{{ item.label }}</h6>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="tab-content dark-field shipping-content" id="cart-options-tabContent">
                            <Order/>
                            <Shipping/>
                            <Payment />
                            <Finish />
                        </div>
                    </div>
                    <Cart/>
                </div>
            </div>
        </div>
    </Card3>
</template>
<script lang="ts" setup>
import { ref,watch, defineAsyncComponent, onMounted } from 'vue'

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const Order = defineAsyncComponent(() => import("./Order.vue"))
const Shipping = defineAsyncComponent(() => import("./Shipping.vue"))
const Payment = defineAsyncComponent(() => import("./Payment.vue"))
const Finish = defineAsyncComponent(() => import("./Finish.vue"))
const Cart = defineAsyncComponent(() => import("./Cart.vue"))

import { usePosStore } from "./pos";
const usePos = usePosStore();
const tab = [
  {
    id: 'order-wizard-tab',
    href: '#order-wizard',
    icon: 'fa-cart-shopping',
    label: 'Order'
  },
  {
    id: 'shipping-wizard-tab', 
    href: '#shipping-wizard',
    icon: 'fa-truck',
    label: 'Shipping'
  },
  {
    id: 'payment-wizard-tab',
    href: '#payment-wizard', 
    icon: 'fa-credit-card',
    label: 'Payment'
  },
  {
    id: 'finish-wizard-tab',
    href: '#finish-wizard',
    icon: 'fa-check',
    label: 'Finish'
  }
]


const divisiOptions = ref<{ ID: any, name: string }[]>([])
const divisiTeamOptions = ref<{ ID: any, name: string }[]>([])
import * as master from "@/api/services/MasterRequest";

const fetchDivisi = async () => {
    try {
        // Simulate API delay
        const resp = await master.postRequest("/divisi/list", {page:1, size:10000,search:''});
        divisiOptions.value = resp.data;
    } catch (error) {
    }
}
const datetime = ref(new Date());
let clockInterval: number | null = null;
onMounted(() => {
    clockInterval = window.setInterval(() => {
        datetime.value = new Date();
        usePos.formPos.transaction_date = datetime.value;
    }, 1000);

    fetchDivisi();
    usePos.resetFormPos('order');
    usePos.formPos.divisi = null
    usePos.formPos.divisi_team = null
    usePos.showDivisionModal = true
})

watch(() => usePos.formPos.divisi, (newDivisi) => {
    if (newDivisi && newDivisi.divisiTeams) {
        divisiTeamOptions.value = newDivisi.divisiTeams
        usePos.formPos.divisi_team = null // reset  selection
    } else {
        divisiTeamOptions.value = []
        usePos.formPos.divisi_team = null
    }
})
</script>